import { Breadcrumb, type BreadcrumbProps } from "antd";
import { Link } from "react-router";

export default function CustomBreadcrumb({
  items,
}: {
  items: BreadcrumbProps["items"];
}) {
  return (
    <Breadcrumb
      style={{ direction: "rtl" }}
      classNames={{
        item: "last:text-grayscale-400! last:text-16-regular! text-16-semi-bold! text-grayscale-950!",
        separator: "text-18-regular!",
      }}
      items={items}
      itemRender={(route) => {
        return route.href ? (
          <Link
            className="text-16-semi-bold! text-grayscale-950!"
            to={route.href}
          >
            {route.title}
          </Link>
        ) : (
          <span className="text-grayscale-400! text-16-regular!">
            {route.title}
          </span>
        );
      }}
    />
  );
}
